import { sendParent } from 'xstate5';

import { type CustomizationMachineAction, type ParentEvent } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Tells the parent the product is in the bag.
 */
export const reportAddedToBag: CustomizationMachineAction = sendParent(
  (args): ParentEvent => ({
    type: 'customization.added-to-bag',
    actorId: args.self.id,
  }),
);
